import './App.css';
import MazePathfinder from './MazePathfinder';

function App() {
  return (
    <div className="App">
      <MazePathfinder />
    </div>
  );
}

export default App;